/**
 * External-user roles offered to customers via the registration dropdown
 * (CX-1146 AC1) and the post-login role-selection modal (CX-2385). Internal
 * Covestro users are not represented here — they authenticate via Azure SSO
 * and bypass the modal entirely.
 */
export const EXTERNAL_ROLES = [
  "CMF Expert",
  "Product Designer",
  "Product Development Engineer",
  "Strategic Procurement",
  "Purchaser",
  "Distributor",
  "Other",
] as const;

export type PredefinedRole = (typeof EXTERNAL_ROLES)[number];
